/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'tags': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M38.289 26.803l-8.878 8.878c-.193.193-.517.111-.713-.082l-1.595-1.604 7.19-7.191c.528-.527.487-.928 0-1.414L20.894 12h3.005c.275 0 .905.08 1.064.177.158.097.448.336.643.53L38.29 25.389c.358.359.42.993-.001 1.414z"/><path pid="1" d="M19.252 12.354a1.386 1.386 0 0 0-.854-.354H9.5c-.275 0-.5.225-.5.5v8.899c0 .274.159.659.353.853l13.389 13.39a.504.504 0 0 0 .707 0l9.193-9.193a.504.504 0 0 0 0-.707l-13.39-13.388zm-3.838 6.06a2 2 0 1 1-2.828-2.828 2 2 0 0 1 2.828 2.828z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/tags.js